import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Modal from '../UI/Modal/Modal';
import { updateArtisanPreferences } from '../../Store/Actions/authActions';

const ArtisanPreferenceModal = ({
  opened,
  close,
  profile,
  field,
  title,
  description,
  label,
  options,
  save,
  loading,
}) => {
  const currentValue = profile?.[field] || '';
  const [value, setValue] = useState(currentValue);

  useEffect(() => {
    if (opened) setValue(currentValue);
  }, [opened, currentValue]);

  const submit = async (event) => {
    event.preventDefault();
    if (!value || value === currentValue) return;
    const success = await save({ [field]: value });
    if (success) close?.();
  };

  return (
    <Modal opened={opened} close={loading ? undefined : close}>
      <Header>
        <div>
          <Kicker>Profil artisan</Kicker>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </div>
        <CloseButton type="button" aria-label="Fermer" onClick={close} disabled={loading}>×</CloseButton>
      </Header>
      <form onSubmit={submit}>
        <Field>
          <span>Valeur actuelle</span>
          <Current>{options.find((option) => option.value === currentValue)?.label || currentValue || 'Non renseignée'}</Current>
        </Field>
        <Field>
          <label htmlFor={`artisan-${field}`}>{label}</label>
          <Select id={`artisan-${field}`} value={value} onChange={(event) => setValue(event.target.value)}>
            <option value="">Sélectionnez une option</option>
            {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
          </Select>
        </Field>
        <Actions>
          <Secondary type="button" onClick={close} disabled={loading}>Annuler</Secondary>
          <Primary type="submit" disabled={loading || !value || value === currentValue}>
            {loading ? 'Enregistrement…' : 'Enregistrer'}
          </Primary>
        </Actions>
      </form>
    </Modal>
  );
};

const Header = styled.header`display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; margin-bottom: 1.3rem;`;
const Kicker = styled.div`margin-bottom: .35rem; color: #a88a5d; font-size: .76rem; font-weight: 900; letter-spacing: .1em; text-transform: uppercase;`;
const Title = styled.h2`margin: 0; color: #111111; font-size: 1.55rem;`;
const Description = styled.p`margin: .5rem 0 0; color: #687682; line-height: 1.55;`;
const CloseButton = styled.button`width: 2.5rem; height: 2.5rem; border: 0; border-radius: 50%; background: #f1ece5; color: #111111; font: inherit; font-size: 1.6rem; cursor: pointer; &:disabled { opacity: .5; }`;
const Field = styled.div`display: grid; gap: .45rem; margin-top: 1rem; span, label { color: #53616d; font-size: .82rem; font-weight: 800; }`;
const Current = styled.div`padding: .85rem 1rem; border-radius: .85rem; background: #faf8f4; color: #111111; font-weight: 700;`;
const Select = styled.select`width: 100%; min-height: 3rem; padding: 0 .9rem; border: 1px solid #ddd3c4; border-radius: .85rem; background: #fff; color: #111111; font: inherit;`;
const Actions = styled.div`display: flex; justify-content: flex-end; gap: .7rem; margin-top: 1.5rem; @media (max-width: 500px) { flex-direction: column-reverse; }`;
const BaseButton = styled.button`min-height: 2.8rem; padding: .7rem 1.1rem; border-radius: 999px; font: inherit; font-weight: 850; cursor: pointer; &:disabled { opacity: .5; cursor: not-allowed; }`;
const Secondary = styled(BaseButton)`border: 1px solid #d5dde3; background: #fff; color: #4d5a64;`;
const Primary = styled(BaseButton)`border: 1px solid #c0a375; background: #c0a375; color: #111111;`;

const mapStateToProps = ({ firebase, auth }) => ({
  profile: firebase.profile || {},
  loading: auth?.profileEdit?.loading || false,
});
const mapDispatchToProps = { save: updateArtisanPreferences };
export default connect(mapStateToProps, mapDispatchToProps)(ArtisanPreferenceModal);
